module.exports = __webpack_public_path__ + "img/guardian_lotofarmor.b738ecc5.png";